/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'partners-group',
        title   : '',
        subtitle: '',
        type    : 'group',
        children: [
            {
                id   : 'dashboard',
                title: 'common.menu.dashboard',
                type : 'basic',
                icon : 'heroicons_outline:home',
                link : '/dashboard',
                role : 'other',
            },
            {
                id   : 'teams',
                title: 'common.menu.teams',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/teams',
                role : 'other',
            },
            {
                id   : 'invoice',
                title: 'common.menu.invoice',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/invoices',
                role : 'other',
            },
            {
                id   : 'customers',
                title: 'common.menu.customers',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/customers',
                role : 'other',
            },
            {
                id   : 'notifications',
                title: 'common.menu.notifications',
                type : 'basic',
                icon : 'heroicons_outline:bell',
                link : '/notifications',
                role : 'other',
            }
        ]
    },
    {
        id      : 'app-group',
        title   : 'common.menu.app',
        type    : 'group',
        icon : 'heroicons_outline:information-circle',
        children: [
            {
                id   : 'users',
                title: 'common.menu.users',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/users',
                role : 'other',
            },
            {
                id   : 'admin-invoicing',
                title: 'common.menu.adminInvoicing',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-copy',
                link : '/invoicing',
                role : 'other',
            },
            {
                id   : 'accesses',
                title: 'common.menu.accesses',
                type : 'basic',
                icon : 'heroicons_outline:eye',
                link : '/accesses',
                role : 'other',
            },
            {
                id   : 'notification-types',
                title: 'common.menu.notificationTypes',
                type : 'basic',
                icon : 'heroicons_outline:bell',
                link : '/notification-types',
                role : 'other',
            },
            {
                id   : 'notification-flow',
                title: 'common.menu.notificationFlow',
                type : 'basic',
                icon : 'heroicons_outline:switch-vertical',
                link : '/notification-flow/admin',
                role : 'other',
            },
            {
                id   : 'support',
                title: 'common.menu.support',
                type : 'basic',
                icon : 'heroicons_outline:question-mark-circle',
                link : '/support'
            },
            {
                id   : 'changelog',
                title: 'common.menu.changelog',
                type : 'basic',
                icon : 'heroicons_outline:newspaper',
                link : '/changelog'
            },
        ]
    }



    ];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'common.menu.dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
        role : 'other',
    },
    {
        id   : 'teams',
        title: 'common.menu.teams',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/teams',
        role : 'other',
    },
    {
        id   : 'invoice',
        title: 'common.menu.invoice',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/invoices',
        role : 'other',
    },
    {
        id   : 'customers',
        title: 'common.menu.customers',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/customers',
        role : 'other',
    },
    {
        id   : 'notifications',
        title: 'common.menu.notifications',
        type : 'basic',
        icon : 'heroicons_outline:bell',
        link : '/notifications',
        role : 'other',
    },
    {
        id      : 'app-group',
        title   : 'common.menu.app',
        // subtitle: 'Vše co potřebujete vědět',
        type    : 'group',
        icon : 'heroicons_outline:information-circle',
        children: [
            {
                id   : 'users',
                title: 'common.menu.users',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/users',
                role : 'other',
            },
            {
                id   : 'admin-invoicing',
                title: 'common.menu.adminInvoicing',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-copy',
                link : '/invoicing',
                role : 'other',
            },
            {
                id   : 'accesses',
                title: 'common.menu.accesses',
                type : 'basic',
                icon : 'heroicons_outline:eye',
                link : '/accesses',
                role : 'other',
            },
            {
                id   : 'notification-types',
                title: 'common.menu.notificationTypes',
                type : 'basic',
                icon : 'heroicons_outline:bell',
                link : '/notification-types',
                role : 'other',
            },
            {
                id   : 'notification-flow',
                title: 'common.menu.notificationFlow',
                type : 'basic',
                icon : 'heroicons_outline:switch-vertical',
                link : '/notification-flow/admin',
                role : 'other',
            },
            {
                id   : 'support',
                title: 'common.menu.support',
                type : 'basic',
                icon : 'heroicons_outline:question-mark-circle',
                link : '/support'
            },
            {
                id   : 'changelog',
                title: 'common.menu.changelog',
                type : 'basic',
                icon : 'heroicons_outline:newspaper',
                link : '/changelog'
            },
        ]
    }
];

// - NOT ADMIN  ------------------------

export const defaultNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id      : 'partners-group',
        title   : '',
        subtitle: '',
        type    : 'group',
        children: [
            {
                id   : 'dashboard',
                title: 'common.menu.dashboard',
                type : 'basic',
                icon : 'heroicons_outline:home',
                link : '/dashboard',
                role : 'other',
            },
            {
                id   : 'invoice',
                title: 'common.menu.invoice',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/invoices',
                role : 'other',
            },
            {
                id   : 'customers',
                title: 'common.menu.customers',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/customers',
                role : 'other',
            }
        ]
    }

];


export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'common.menu.dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
        role : 'other',
    },
    {
        id   : 'invoice',
        title: 'common.menu.invoice',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/invoices',
        role : 'other',
    },
    {
        id   : 'customers',
        title: 'common.menu.customers',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/customers',
        role : 'other',
    }
];
